import $http from '../../shared/http';

export const service_activities = {
  namespaced: true,
  state: () => {
    return {
      serviceActivities: null,
      serviceActivitiesForSelect: null,
      ServiceActivityData: null,
    };
  },
  getters: {
    getServiceActivities: (state) => state.serviceActivities,
    getServiceActivitiesForSelect: (state) => state.serviceActivitiesForSelect,
    getServiceActivityData: (state) => state.ServiceActivityData,
  },
  mutations: {
    setServiceActivities: (state, payload) => (state.serviceActivities = payload),
    setServiceActivitiesForSelect: (state, payload) => (state.serviceActivitiesForSelect = payload),
    setServiceActivityData: (state, payload) => (state.ServiceActivityData = payload),
  },
  actions: {
    async loadServiceActivitiesAction({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get('/service-activities/list')
          .then((response) => {
            commit('setServiceActivities', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async loadServiceActivities({ commit }, { churchId }) {
      return $http('v2')
        .get(`/organisations/${churchId}/service_activities`, {
          canBeImpersonated: true,
        })
        .then((response) => {
          commit('setServiceActivitiesForSelect', response.data.data);
          return response;
        });
    },

    async createServiceActivitiesAction(ctx, activities) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/service-activities`, { activities }, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async () => {
            return resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_SERVICE_ACTIVITY_DATA({ commit }, ID) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/service-activities/${ID}`)
          .then(async (response) => {
            commit('setServiceActivityData', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async EDIT_SERVICE_ACTIVITY(ctx, { form, ID }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/service-activities/${ID}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async DELETE_SERVICE_ACTIVITY(ctx, { id }) {
      return $http()
        .delete(`/service-activities/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
};
